import "./GhostImageComponent.scss";
import template from "./GhostImageComponent.html";
import {IComponentOptions} from "angular";

export const GhostImage = "tfGhostImage";

export function ghostImage(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: GhostImageComponentController
    };
}

export class GhostImageComponentController {

    /** @ngInject */
    public constructor() {

    }
}
